import acceptTermsModalCtrl from 'modals/acceptTerms/controller';
import addVenueLayoutModalCtrl from 'modals/addVenueLayout/controller';
import admissionGroupCommissionsModalCtrl from 'modals/admissionGroupCommissions/controller';
import admissionGroupNotVisibleModalCtrl from 'modals/admissionGroupNotVisible/controller';
import bulkAddAdmissionGroupsModalCtrl from 'modals/bulkAddAdmissionGroups/controller';
import confirmationModalCtrl from 'modals/confirmation/controller';
import confirmationInventoryModalCtrl from 'modals/confirmationInventory/controller';
import confirmationEventModalCtrl from 'modals/confirmationEvent/controller';
import migrateInventoryModalCtrl from 'modals/migrateInventory/controller';
import editScheduledReportModalCtrl from 'modals/editScheduledReport/controller';
import mergeAttributionsModalCtrl from 'modals/mergeAttributions/controller';
import mergeCustomersModalCtrl from 'modals/mergeCustomers/controller';
import attributionLinksEmailModalCtrl from 'modals/attributionLinksEmail/controller';
import inventoryQrCodeModalCtrl from 'modals/inventoryQrCode/controller';
import confirmationPaymentRequestNotificationModalCtrl from 'modals/confirmationPaymentRequestNotification/controller';

function init(app) {
  if (!app) throw new Error('app is required');

  app.controller('acceptTermsModalCtrl', acceptTermsModalCtrl);
  app.controller('addVenueLayoutModalCtrl', addVenueLayoutModalCtrl);
  app.controller('admissionGroupCommissionsModalCtrl', admissionGroupCommissionsModalCtrl);
  app.controller('admissionGroupNotVisibleModalCtrl', admissionGroupNotVisibleModalCtrl);
  app.controller('bulkAddAdmissionGroupsModalCtrl', bulkAddAdmissionGroupsModalCtrl);
  app.controller('confirmationModalCtrl', confirmationModalCtrl);
  app.controller('confirmationInventoryModalCtrl', confirmationInventoryModalCtrl);
  app.controller('confirmationEventModalCtrl', confirmationEventModalCtrl);
  app.controller('migrateInventoryModalCtrl', migrateInventoryModalCtrl);
  app.controller('editScheduledReportModalCtrl', editScheduledReportModalCtrl);
  app.controller('mergeAttributionsModalCtrl', mergeAttributionsModalCtrl);
  app.controller('mergeCustomersModalCtrl', mergeCustomersModalCtrl);
  app.controller('attributionLinksEmailModalCtrl', attributionLinksEmailModalCtrl);
  app.controller('inventoryQrCodeModalCtrl', inventoryQrCodeModalCtrl);
  app.controller('confirmationPaymentRequestNotificationModalCtrl', confirmationPaymentRequestNotificationModalCtrl);
}

export default {
  init
};



// WEBPACK FOOTER //
// ./src/modals/index.js